import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

export const PremiumOnboarding: LoadableType<{}> = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PremiumOnboarding" */ '../src/PremiumOnboarding.tsx'
			)
		).PremiumOnboarding,
});
